import api from ".";

export const yearCrud = (data, method, callBack) => {
    let path = data?.id 
        ? `/years/${data.id}/` 
        : '/years/';

    const payload = { ...data };
    if (method !== 'get') {
        delete payload.id;
    }

    const config = method === 'get' && !data?.id 
        ? { params: data } 
        : payload;

    api[method](path, config)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};
